import React from 'react';
import BaseSwiper from '@/components/swiper/BaseSwiper';

const SeoSwiper = (props: {
  chunkData: any[];
  swiperEle: (data: any) => React.ReactNode;
  slideClassName?: string;
  chunkSize?: number;
  tag?: string;
}) => {
  const {
    chunkData,
    swiperEle,
    slideClassName = 'grid-cols-4 grid-rows-3',
    chunkSize = 12,
    tag = 'ul',
  } = props;
  return (
    <BaseSwiper
      className="hidden tablet:block"
      chunkData={chunkData}
      chunkSize={chunkSize}
      slideClassName={
        'grid gap-x-4 gap-y-6 ml-0 swiper-no-swiping ' + slideClassName
      }
      swiperEle={swiperEle}
      tag={tag}
      spaceBetween={0}
      bulletSx={{
        '.swiper-pagination-bullet': {
          height: '4px',
          width: '24px',
          borderRadius: '4px',
          backgroundColor: '#bfdbfe',
          margin: '0 4px 0 0 !important',
          transition: 'background-color .5s ease,width .3s linear',
          '&s': { position: 'initial', marginTop: '8px' },
          '&:not(&-active):hover': {
            backgroundColor: '#93c5fd !important',
          },
          '&-active': {
            backgroundColor: '#0050b3',
          },
        },
      }}
    />
  );
};

export default SeoSwiper;
